import { formatBytes } from "@jkast90/kast-common/format";

/**
 * A file's size as CloudBoy has always shown it: whole kilobytes below a
 * megabyte ("32 KB", where a save's power-of-two size would otherwise read
 * "32.0 KB"), one decimal from there ("1.3 MB"). kast-common's formatBytes;
 * under a kilobyte it reads "512 B".
 */
export function formatSize(bytes: number): string {
  return formatBytes(bytes, { decimals: bytes >= 1024 * 1024 ? 1 : 0 });
}
